/** @typedef {import('../poker/cards.js').Card} Card */

/**
 * @param {Card} c
 * @returns {boolean}
 */
export function isAce(c) {
  return c.rank === 14;
}

/**
 * 10, J, Q, K (ranks 10–13).
 * @param {Card} c
 */
export function isTenValueCard(c) {
  return c.rank >= 10 && c.rank <= 13;
}

/**
 * @param {Card[]} cards
 * @returns {{ total: number, soft: boolean }}
 */
export function handValue(cards) {
  let hard = 0;
  let aces = 0;
  for (const c of cards) {
    if (isAce(c)) aces += 1;
    else if (isTenValueCard(c)) hard += 10;
    else hard += c.rank;
  }
  if (aces === 0) {
    return { total: hard, soft: false };
  }
  const withBigAce = hard + aces + 10;
  if (withBigAce <= 21) {
    return { total: withBigAce, soft: true };
  }
  return { total: hard + aces, soft: false };
}

/**
 * Natural blackjack: exactly two cards, Ace + ten-value.
 * @param {Card[]} cards
 */
export function isNaturalBlackjack(cards) {
  if (!cards || cards.length !== 2) return false;
  const a = cards[0];
  const b = cards[1];
  return (isAce(a) && isTenValueCard(b)) || (isAce(b) && isTenValueCard(a));
}

/**
 * @param {Card[]} cards
 */
export function isBust(cards) {
  return handValue(cards).total > 21;
}

/**
 * Same rank only (10 and J cannot split).
 * @param {Card[]} cards
 * @param {number} numHandsInSeat
 */
export function canSplitPair(cards, numHandsInSeat) {
  if (numHandsInSeat >= 2) return false;
  if (!cards || cards.length !== 2) return false;
  return cards[0].rank === cards[1].rank;
}

/**
 * Dealer upcard warrants checking hole for blackjack (10/J/Q/K/A).
 * @param {Card|null} up
 */
export function dealerUpcardIsTenOrAce(up) {
  if (!up) return false;
  return isTenValueCard(up) || isAce(up);
}
